import React from 'react'

export default function Knight() {
  return <span>♘</span>
}